<template>
  <div>
    
    
    <v-container fluid grid-list-md>
        <v-dialog v-model="details.visible" fullscreen hide-overlay transition="dialog-bottom-transition">
          <v-card>
            <v-toolbar>
              <v-btn icon @click="closeDetails()">
                <v-icon>close</v-icon>
              </v-btn>
              <v-toolbar-title>{{details.ticketnum}} {{ details.name }}</v-toolbar-title>
            </v-toolbar>
            <v-layout row>
              <v-flex xs12 sm7 md9 d-flex>
                <v-layout column>
                  <v-list three-line subheader>
                    <v-subheader>
                      <span>{{ details.description }}</span>
                    </v-subheader>
                  </v-list>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm5 md3 d-flex>
                <div v-if="details.assigneduser" class="support">
                  <h3>Ihr Ansprechpartner</h3>
                  <sec-img v-if="details.assigneduser" :src="getImageUrl(details.assigneduser)" class="profile-picture"></sec-img>
                  <h4 class="silver">{{details.support.name}}</h4>
                  <div><a v-if="details.support.email" :href="`mailto:${details.support.email}`" class="silver">{{details.support.email}}</a></div>
                  <div><a v-if="details.support.phone" :href="`tel:${details.support.phone}`" class="silver">{{details.support.phone}}</a></div>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-dialog>


                <v-flex xs12 sm6 d-flex class="pl-3">
          <v-text-field
            v-model="state.filter"
            flat
            :label="$t('Action.search')"
            append-icon="search"
            hide-details
            clearable
            style="padding-bottom: 20px"
            @change="setFilter"
            @click:clear="setFilter('')"
          ></v-text-field>
        </v-flex>

        <h1>{{ $t(`Application.tickets`) }}</h1>
        <v-data-table
          :headers="headers"
          :items="tickets"
          :rows-per-page-items="rowsPerPageItems"
          :pagination.sync="state.pagination"
          :total-items = "state.pagination.totalItems"
          must-sort
          @update:pagination="onUpdatePagination"
          class="elevation-1 mt-3"
        >
        

          <template slot="headerCell" slot-scope="props">
            <template v-if="props.header.value === 'transactionnum'" class="qwerty">
              <span class="filter-column-text">{{ $t(props.header.text) }}</span>
              <v-edit-dialog
                ref="filter-transactionnum"
                lazy
                :class="'filter-column-editor' + (state.filter ? ' active' : '')"
              >
                <v-icon class="ml-1 mr-1" @click.stop="onSearchClick">search</v-icon>
                <v-text-field
                  slot="input"
                  v-model="state.filter"
                  :label="$t('Common.filterText')"
                  clearable
                  single-line
                  @change="onFilterChanged"
                ></v-text-field>
              </v-edit-dialog>
            </template>

            <span v-else>{{ $t(props.header.text) }}</span>
          </template>

          <template slot="items" slot-scope="props">
            <tr
              @click="openDetails(props.item)">
              <td
                v-for="header in headers"
              :key="header.value"
              :class="header.align ? 'text-xs-' + header.align : undefined"
              >
                {{getTicketValue(props.item, header, $i18n.locale)}}
              </td>
            </tr>
          </template>

        </v-data-table>
    </v-container>
  </div>
</template>

<script>
  import store from '../store'
  import { saveAs } from 'file-saver'

  export default {
    name: 'Tickets',
    props: {
      config: Object,
    },
    mounted() {
      this.closeDetails = this.closeDetails.bind(this);
    },
    computed: {
      state() {
        if(!store[this.config.type]) {
          store[this.config.type] = {
            pagination: {},
            filter: ''
          };
        }
        return store[this.config.type];
      }
    },
    data() {
      const headers = [];
      const sourceMapper = {};

      if (this.config.columns) {
        this.config.columns.forEach(col => {
          const value = col.field.replace('.', '');
          headers.push({
            text: col.label,
            value,
            sortable: col.sortable,
            align: col.align,
            width: col.width,
            type: col.type,
          });
          sourceMapper[col.field] = value;
        });
      }

      return {
        headers,
        sourceMapper,
        rowsPerPageItems: [6, 12, 24, { "text": "$vuetify.dataIterator.rowsPerPageAll", "value": -1 }],
        tickets: [],
        details: {},
      };
    },
    methods: {
      getImageUrl(ID) {
        return this.$root.route(`dashboard/customerservice/${ID}/image`)
      },
      refresh() {
        const params = {
          offset: (this.state.pagination.page || 1) - 1,
          limit: this.state.pagination.rowsPerPage
        };
        if (this.state.pagination.sortBy) {
          params['orderby'] = (this.state.pagination.descending ? '-' : '') + this.state.pagination.sortBy;
        }
        if (this.state.filter) {
          params['search'] = this.state.filter;
        }

        this.$http.get(this.$root.route('tickets'), {params}).then(
          response => {
            this.tickets = response.body.result.data;
            this.tickets = this.tickets.map(ticket => {
              let res = Object
                .keys(this.sourceMapper)
                .reduce((p, c) => {
                  let currentVal = ticket;
                  c.split('.').forEach((prop, i)=> {
                    if (currentVal !== null && currentVal !== undefined) {
                      currentVal = currentVal[prop];
                    }
                  });
                  p[this.sourceMapper[c]] = currentVal;
                  return p;
                }, {});
              return { ...ticket, ...res, };
            });
            this.state.pagination.totalItems = response.body.result.count;
          },
          response => {
            console.log('Fail', response);
          });
      },

        setFilter(value) {
        this.state.filter = value;
        this.refresh();
      },
      openDetails(ticket) {
        this.$http.get(this.$root.route('ticket/' + ticket.ID), {})
        .then(
          ({body}) => {
            console.log('Details', JSON.stringify(body, null, 3));
            this.details = {
              ...body.result,
              visible: true,
            }

            history.pushState(null, document.title, location.href);
            window.addEventListener('popstate', this.closeDetails);
          },
          response => {
            console.log('Fail', response);
          });
      },
      closeDetails() {
        this.details = {
          ...this.details,
          visible: false,
        };
        window.removeEventListener('popstate', this.closeDetails);
      },
      onUpdatePagination(paginationObject) {
        Object.keys(paginationObject).forEach(key => this.state.pagination[key] = paginationObject[key]);
        this.refresh()
      },
      onFilterChanged() {
        this.$refs['filter-transactionnum'].isActive = false;
        this.refresh();
      },
      onSearchClick() {
        this.$refs['filter-transactionnum'].isActive = true;
      },
      getTicketValue(ticket, header, i18nLocale) {
        const res = ticket[header.value];
        if (header.type === 'num') {
          return res.toLocaleString(i18nLocale, {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }
        if (header.type === 'date') {
          return !res ? '-' : new Date(res * 1000).toLocaleDateString(
            i18nLocale, {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric'
            });
        }
        return res;
      }
    }
  }
</script>

<style lang="scss" scoped>
    .profile-picture {
        max-width: 50%;
        border-radius: 50%;
    }
    
    .v-card.theme--dark .layout.row {
        background: #424242
    }
    
    .support {
        text-align: center;
        margin-top: 16px;
    }
    
    .theme--dark.v-card {
        background: #424242 !important;
    }

    .support > h4 {
        margin-top: 16px;
        margin-bottom: 16px;
    }

    .silver {
        color: gray;
    }
    .v-list.v-list--subheader.v-list--three-line.theme--dark {
        padding-top: 3rem !important;
    }
</style>
